<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_xi">THE RETURN OF NATURE</a></p><a id="page_xi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Fm03.vue?19388b97